module.exports = "<div> <div class=google-maps-map ng-style=mapStyles></div> </div>";